import { createFileRoute } from '@tanstack/react-router'

import { PlanSelectionPage } from '~/boundedContext/subscription/pages/plan-selection-page'

import { planSelectionSearchSchema } from './checkout/-schemas/plan-selection-search-schema'

export const Route = createFileRoute('/subscription/')({
  component: PlanSelectionPage,
  validateSearch: search => planSelectionSearchSchema.parse(search),
})
